var _circle, _circle2, _circle3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaDotsVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(1 0 0 -1 2 2.125)",
    fill: "url(#paint0_linear_850_760)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(1 0 0 -1 2 8.125)",
    fill: "url(#paint1_linear_850_760)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(1 0 0 -1 2 14.125)",
    fill: "url(#paint2_linear_850_760)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_850_760",
    x1: 0.299617,
    y1: 2,
    x2: 3.55022,
    y2: 2.03718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_850_760",
    x1: 0.299617,
    y1: 2,
    x2: 3.55022,
    y2: 2.03718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_850_760",
    x1: 0.299617,
    y1: 2,
    x2: 3.55022,
    y2: 2.03718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaDotsVertical);
export default __webpack_public_path__ + "static/media/faDotsVertical.cc97951dd9e5ccf31cc0d26710e083bb.svg";
export { ForwardRef as ReactComponent };